import { api } from '@creditsights/api-ui-web';
import isEmpty from 'lodash/isEmpty';
import { read, utils } from 'xlsx';
import fileDownload from 'js-file-download';

import { EM_DASH } from '../../../../Base.constants';
import { ISSUERS_LIMIT_PER_WATCHLIST } from '../Watchlist/Watchlist.logic';
import { File } from './UploadFile/UploadFile';

export const TEMPLATE_FILE_NAME = 'Watchlist Template.xlsx';

export const downloadTemplate = async (): Promise<void> => {
  const { location } = window;
  const baseUrl = `${location.protocol}//${location.host}`;
  const { data } = await api.get(encodeURIComponent(TEMPLATE_FILE_NAME), {
    responseType: 'blob',
    baseURL: baseUrl,
  });
  fileDownload(data, TEMPLATE_FILE_NAME);
};

export const readXlsx = (file: File): string[] => {
  const workbook = read(file.data, { type: 'array' });
  const workSheet = workbook.Sheets[workbook.SheetNames[0]];

  const tickers = utils
    .sheet_to_json<string>(workSheet, {
      header: 1,
      blankrows: false,
      range: utils.decode_range(`A1:A${ISSUERS_LIMIT_PER_WATCHLIST + 1}`),
    })
    .map((row) => row[0])
    .filter((ticker) => !isEmpty(ticker) && ticker !== EM_DASH && !['ticker', 'issuer'].includes(ticker.toLowerCase()))
    .slice(0, ISSUERS_LIMIT_PER_WATCHLIST);

  if (isEmpty(tickers)) {
    throw new Error('No tickers');
  }

  return tickers;
};
